import React, { Fragment } from 'react';
import { BackButton } from './back-button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

export const SubMenuHeader = ({ channel, channelId, goToChannel, changeId }) => {
  if (!(channelId && channelId !== -1)) {
    return null;
  }
  return (
    <Fragment>
      <BackButton onClick={() => changeId(channel.parentId)} />
      <button
        data-e2e={`mobile-nav-item-${channel.id}`}
        className="ct-mobile-menu__list-elem ct-mobile-menu__list-elem--parent"
        onClick={() => goToChannel(channel.url)}
        tabIndex={0}
      >
        {channel.title} <FontAwesomeIcon icon={faAngleRight} aria-hidden="true" />
      </button>
    </Fragment>
  );
};
